<template>
    <div class="col-10 box-border d-flex flex-wrap align-items-start">
        <div class="col-3 break-col">
            <caption class="c-nmidone">Endereço</caption>
            <h5 v-if="info.street" class="c-ndarkfour mb-0 break d-inline-block">{{info.street | formatName }}</h5>
            <h5 v-else class="c-ndarkfour mb-0">-</h5>
        </div>
        <div class="col-2">
            <caption class="c-nmidone">Número</caption>
            <h5 v-if="info.number || info.number == 0" class="c-ndarkfour mb-0">{{info.number}}</h5>
            <h5 v-else class="c-ndarkfour mb-0">-</h5>
        </div>
        <div class="col-2 break-col">
            <caption class="c-nmidone">Complemento</caption>
            <h5 v-if="info.complement" class="c-ndarkfour mb-0 break d-inline-block">{{info.complement}}</h5>
            <h5 v-else class="c-ndarkfour mb-0">-</h5>
        </div>
        <div class="col-2 break-col">
            <caption class="c-nmidone">Cidade</caption>
            <h5 v-if="info.city" class="c-ndarkfour mb-0 break d-inline-block">{{info.city | formatName }}</h5>
            <h5 v-else class="c-ndarkfour mb-0 d-inline-block">-</h5>
        </div>
        <div class="col-2">
            <caption class="c-nmidone">Estado</caption>
            <h5 v-if="info.state" class="c-ndarkfour mb-0">{{info.state}}</h5>
            <h5 v-else class="c-ndarkfour mb-0">-</h5>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        info:{
            required:true,
        }
    },
    components:{
    }
}
</script>

<style lang="scss" scoped>
</style>